import React from 'react';
// import './SecretCodePopup.css';

const SecretCodePopup = ({ secretCode, setSecretCode, handleSecretCodeSubmit }) => {
    return (
        <div className="popup">
            <div className="popup-inner">
                <h2>Enter Secret Code</h2>
                <input
                    type="text"
                    value={secretCode}
                    onChange={(e) => setSecretCode(e.target.value)}
                    placeholder="Secret Code"
                />
                <button onClick={handleSecretCodeSubmit}>Submit</button>
            </div>
        </div>
    );
};

export default SecretCodePopup;
